let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hSg3u")).then(() => parcelRequire('je9tT'));